import { render, staticRenderFns } from "./PessoaDiabetes.vue?vue&type=template&id=723ecb56"
import script from "./PessoaDiabetes.vue?vue&type=script&lang=js"
export * from "./PessoaDiabetes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports